export default "__VITE_ASSET__C40EAytK__"